export default __webpack_public_path__ + "static/140-min-min-a73381f53515495e5973b6ae535f1357.jpg";